import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: false,
};

const navbarMobileMenu = createSlice({
  name: 'navbarMobileMenu',
  initialState,
  reducers: {
    setNavbarMobileMenuOpen: (state, action) => {
      state.isOpen = action.payload;
    },
    toggleNavbarMobileMenu: (state) => {
      state.isOpen = !state.isOpen;
    },
  },
});

export const { setNavbarMobileMenuOpen, toggleNavbarMobileMenu } = navbarMobileMenu.actions;

export default navbarMobileMenu.reducer;
